"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VerticalLegend;
var _react = _interopRequireDefault(require("react"));
var d3 = _interopRequireWildcard(require("d3"));
var _styled = require("./styled");
var _types = require("../../charts/types");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function VerticalLegend(_ref) {
  let {
    palette,
    labels,
    format
  } = _ref;
  const colorPalette = d3.scaleOrdinal().domain(labels.map(label => label.key)).range(palette);
  return /*#__PURE__*/_react.default.createElement(_styled.VerticalLegendItems, null, labels.map(label => /*#__PURE__*/_react.default.createElement(_styled.LegendItem, {
    key: label.key
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: colorPalette(label.key)
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      alignmentBaseline: "hanging"
    }
  }, format === _types.ChartCategoricalFormat.LABEL ? label.label || label.key : label.key))));
}